<template>
    <!-- 試算頁跟保障調整共用總計保費 -->
    <div id="count">
        <div class="countPrice">
            <div class="countCon">
                <div class="countLoading" v-if="countLoading">
                    <div class="lds-ring">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                </div>
                <p>總計保費</p>
                <p class="Price clarity-unmask">
                    <span> ${{ formatMoney(calculatePremRes.totalPremium) }}</span> / <span>{{ insureCount }}</span>人
                </p>
            </div>
        </div>
    </div>
</template>
<script setup>
import {onMounted, ref} from "vue";
import Swal from "sweetalert2";
import moment from "moment";
import apiConfig from "@/utils/apiConfig";
import { postApi } from "@/utils/callApi";
import {useRouter} from "vue-router";
    const props = defineProps({
        totalPremium: Number,
        totalCount: Number
    })
    const emits = defineEmits(["countComplete"]);

        const router = useRouter();
        let pageStorage = {};
        const insureCount = ref(0);
        let calculatePremRes = ref({});
        const countLoading = ref(false);
        const loadPageStorage = () =>{
            if(props.totalPremium != null && props.totalCount != null){
                calculatePremRes.value.totalPremium = props.totalPremium;
                insureCount.value = props.totalCount;
                countLoading.value = false;
            }else{
                pageStorage = JSON.parse(sessionStorage.getItem("pageStorage"));
                if (pageStorage != null && pageStorage.mainPlan != null) {
                    insureCounter();
                    calculatePrem();
                }
            }
        }
        const insureCounter =()=> {
            insureCount.value = pageStorage.rosters.length;
        }
        const calculatePrem = () => {
            var effDateTime = moment(pageStorage.startDate).format("YYYY-MM-DD") + ' ' + pageStorage.effTime + ':00';
            var expDateTime = moment(pageStorage.endDate).format("YYYY-MM-DD") + ' ' + pageStorage.effTime + ':00';
            var elderCount = pageStorage.insureCountList[0].count;
            var adultCount = pageStorage.insureCountList[1].count;
            var youthCount = pageStorage.insureCountList[2].count;
            var childCount = pageStorage.insureCountList[3].count;
            var babyCount = pageStorage.insureCountList[4].count;
            var hasSchengenArea = pageStorage.haveSchengenFlag;
            var rosters = pageStorage.rosters;
            //var planCode = pageStorage.mainPlan.planCode;
            var data = {
                "travelArea": "A",
                "effDateTime": effDateTime,
                "expDateTime": expDateTime,
                'planCode':"I01",
                'elderCount': elderCount,
                'adultCount': adultCount,
                'youthCount':youthCount,
                'childCount': childCount,
                'babyCount': babyCount,
                'hasSchengenArea': hasSchengenArea,
                'rosters': rosters
            }
            countLoading.value = true;
            postApi(apiConfig.taiwanPremCalc, null, null, null, data)
                .then((response) => {
                    var taiwanPremCalcRes = response.data;
                    if (taiwanPremCalcRes.code === 200) {
                        countLoading.value = false;
                        calculatePremRes.value = taiwanPremCalcRes.data;
                        pageStorage.calculatePremRes = calculatePremRes.value;
                        sessionStorage.setItem("pageStorage", JSON.stringify(pageStorage));
                        emits('countComplete');

                    } else {
                        //跳出錯誤
                        Swal.fire({
                            title: "保費計算錯誤",
                            showConfirmButton: false,
                            showCloseButton: true,
                            html: '<img src="error.svg" alt="error"><p>'+ taiwanPremCalcRes.message + '</p>',
                        })
                            .then(function () {
                                countLoading.value = false;
                                router.push("/");
                            });
                        countLoading.value = false;

                    }
                })
                .catch((error) => {
                    console.log(error)
                    //跳出錯誤
                    Swal.fire({
                        title: "保費計算錯誤",
                        showConfirmButton: false,
                        showCloseButton: true,
                        html: '<img src="error.svg" alt="error"><p>保費計算連線錯誤</p>',
                    })
                        .then(function () {
                            countLoading.value = false;
                            router.push("/");
                        });
                })

        }
// 總保費加上千分位號","
const formatMoney = (value) => {
    if (value === null || value === undefined) return null;
    return parseFloat(value).toLocaleString("zh-TW", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 50,
    });
};
        onMounted(()=>{
            loadPageStorage();
        })
</script>

<style lang="scss">
#count {
    .red {
        color: $pink
    }

    width:55%;

    @media screen and (max-width: $small) {
        width: 100%
    }

    .countPrice {
        .countCon {
            float: right;
            border: 4px solid $blue-700;
            color: $blue-700;
            border-radius: 10px;
            padding: 5px;
            width: 300px;
            box-sizing: border-box;
            font-weight: bold;
            position: relative;

            .Price {
                font-size: 32px;
                color: $pink;
                text-align: right
            }

            @media screen and (max-width: $small) {
                width: 100%;
                margin: 20px 0;
            }
        }
    }

}

.countArea {
    margin: 20px 0;
    display: flex;
    justify-content: space-between;

    @media screen and (max-width: $small) {
        width: 100%;
        display: block;
    }
}

.countLoading {
    position: absolute;
    right: 40%;
    top: 50%;
}

.lds-ring {
    display: inline-block;
    position: relative;
    width: 20px;
    height: 20px;
}

.lds-ring div {
    box-sizing: border-box;
    display: block;
    position: absolute;
    width: 20px;
    height: 20px;
    margin: 5px;
    border: 5px solid $blue-700;
    border-radius: 50%;
    animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    border-color: $blue-700 transparent transparent transparent;
}

.lds-ring div:nth-child(1) {
    animation-delay: -0.45s;
}

.lds-ring div:nth-child(2) {
    animation-delay: -0.3s;
}

.lds-ring div:nth-child(3) {
    animation-delay: -0.15s;
}

@keyframes lds-ring {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}</style>